import Image from 'next/image'

import certificacaoAbsolarImg from '@assets/certificacao-absolar.webp'
import projetistasAAImg from '@assets/projetistas-nivel-aa.webp'
// import melhoresFranquiasImg from '@assets/melhores-franquias.webp'

import gray360solarImg from '@assets/360solar_gray.webp'

import Script from 'next/script'

interface CertificationsProps {
  className?: string
}

export function Certifications({ className }: CertificationsProps) {
  return (
    <div className={className}>
      <div className="w-full mb-4 md:mb-8">
        <p className="text-xs leading-[1.075rem] font-bold text-v3-gray-400 mb-1 md:text-base md:leading-[1.375rem]">
          Certificações
        </p>

        <div className="w-full flex items-center gap-0 md:gap-3 xl:gap-8">
          <Image
            src={certificacaoAbsolarImg}
            className="w-auto h-[70px] mr-2 sm:mr-6 md:h-[90px] md:mr-0"
            alt="Certificação Absolar"
          />

          <Image
            src={projetistasAAImg}
            className="w-auto h-[70px] mr-3 sm:mr-8 md:h-[90px] md:mr-0"
            alt="Projetistas Nível AA"
          />

          {/* <Image
            src={melhoresFranquiasImg}
            className="w-auto mr-3 sm:mr-8 h-[70px] md:h-[90px] md:mr-0"
            alt="Melhores Franquias do Brasil 2023"
          /> */}

          <div id="ra-verified-seal" className="opacity-1 grayscale"></div>

          <Script
            type="text/javascript"
            id="ra-embed-verified-seal"
            src="https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js"
            data-id="MzU0NDMyOnBvcnRhbC1zb2xhcg=="
            data-target="ra-verified-seal"
            data-model="1"
            strategy="lazyOnload"
          ></Script>
        </div>
      </div>

      <div className="w-full flex md:flex-row justify-between md:max-w-none">
        <div>
          <p className="text-xs leading-4 font-bold text-v3-gray-400 mb-[19px] md:text-base md:leading-[1.375rem]">
            Apoio
          </p>

          <div className="w-full flex items-center gap-2.5 md:gap-2.5 lg:gap-8">
            <Image
              src={gray360solarImg}
              className="w-[150px] h-auto"
              alt="360Solar"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
